// import Main from '@/view/main'

export default {
  path: 'pm',
  meta: {
    title: '商品管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'pm',
  children: [
    {
      path: 'categories',
      meta: {
        title: '商品分类'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '商品分类',
            ignoreBreadCrumb: true,
            notCache: true
          },
          name: 'pm-category-index',
          component: () => import('@/view/pm/categories')
        }
      ]
    },
    {
      path: 'brands',
      meta: {
        title: '品牌分类'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '品牌分类',
            ignoreBreadCrumb: true
          },
          name: 'pm-brand-index',
          component: () => import('@/view/pm/brands')
        },
        {
          path: 'add',
          meta: {
            title: '新增品牌',
            hideInTabBar: true
          },
          name: 'pm-brand-add',
          component: () => import('@/view/pm/brands/edit')
        },
        {
          path: 'edit',
          meta: {
            title: '编辑品牌',
            hideInTabBar: true
          },
          name: 'pm-brand-add',
          component: () => import('@/view/pm/brands/edit')
        },
        {
          path: 'auth',
          meta: {
            title: '品牌审核',
            hideInTabBar: true
          },
          name: 'pm-brand-auth',
          component: () => import('@/view/pm/brands/auth')
        }
      ]
    },
    {
      path: 'brand',
      meta: {
        title: '品牌管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'manage',
          meta: {
            title: '品牌管理',
            ignoreBreadCrumb: true
          },
          name: 'pm-brand-manage',
          component: () => import('@/view/pm/brands/manage')
        },
        {
          path: 'auth',
          meta: {
            title: '品牌审核',
            hideInTabBar: true
          },
          name: 'pm-brand-auth',
          component: () => import('@/view/pm/brands/auth')
        }
      ]
    },
    {
      path: 'attributes',
      meta: {
        title: '商品属性'
      },
      name: 'pm-attributes-entry',
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '商品属性',
            ignoreBreadCrumb: true,
            notCache: true
          },
          name: 'pm-attributes-index',
          component: () => import('@/view/pm/attributes')
        },
        {
          path: 'edit',
          meta: {
            title: '编辑属性',
            hideInTabBar: true
          },
          name: 'pm-attributes-edit',
          component: () => import('@/view/pm/attributes/edit')
        },
        {
          path: 'add',
          meta: {
            title: '新增属性',
            hideInTabBar: true
          },
          name: 'pm-attributes-add',
          component: () => import('@/view/pm/attributes/edit')
        }
      ]
    },
    {
      path: 'units',
      meta: {
        title: '计量单位'
      },
      name: 'pm-units-index',
      component: () => import('@/view/pm/units')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/pm.js